import { connect } from 'react-redux';
import LegalInfoView from './legal-info-presenter';

// Map & Connect
export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison.businessCaseBuilder,
});

const LegalInfo = connect(
  mapStateToProps,
)(LegalInfoView);

export default LegalInfo;
